module.exports = __webpack_public_path__ + "img/migholding.1b3969ea.jpeg";